export class AttachmentModel {
  public id: number;
  public filename: string;
  public creator: string;
  public useridCreate: string;
  public createDate: Date;
  public receiver: string;
  public signatureValid: boolean;
  public checksumValid: boolean;
}
